import Store from './Store';
import StockNotification from '../data/ressources/StockNotification.json'

const StockNotificationStore = new Store('stocknotifications', StockNotification);

export {StockNotificationStore};